// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2lYcZ","anchor":"Header_anchor__3I1iV"};